import type { GeoJSONSource } from 'maplibre-gl';
import type { WeatherSnapshot } from '../../adapters/weather-http';
import type { ResearchLayerMap } from './research-layers';
import { stationSelection } from './weather-selection';

export function weatherPoints(data: WeatherSnapshot | null, areaId: string) {
  const seen = new Set<string>();
  return {
    type: 'FeatureCollection' as const,
    features: (data?.observations ?? []).flatMap((o) => {
      if (
        o.sourceMode !== 'LIVE' ||
        o.locationStatus !== 'LOCATED' ||
        o.latitude === null ||
        o.longitude === null ||
        seen.has(o.input.sourceId) ||
        (areaId && o.regionId !== areaId)
      )
        return [];
      seen.add(o.input.sourceId);
      return [
        {
          type: 'Feature' as const,
          geometry: { type: 'Point' as const, coordinates: [o.longitude, o.latitude] },
          properties: {
            sourceId: o.input.sourceId,
            selectionId: stationSelection(o.input.sourceId),
            sourceMode: 'LIVE',
            label: '真实天气站点（非火灾）',
            health:
              data?.health.find((h) => h.sourceId === o.input.sourceId)?.status ?? 'UNAVAILABLE',
          },
        },
      ];
    }),
  };
}
export function installWeatherLayer(
  map: ResearchLayerMap,
  data: WeatherSnapshot | null,
  areaId: string,
) {
  const id = 'vs11-live-weather',
    points = weatherPoints(data, areaId);
  const source = map.getSource(id) as GeoJSONSource | undefined;
  if (source) source.setData(points);
  else map.addSource(id, { type: 'geojson', data: points });
  if (!map.getLayer(id))
    map.addLayer({
      id,
      source: id,
      type: 'circle',
      paint: {
        'circle-radius': 8,
        'circle-color': ['match', ['get', 'health'], 'CONNECTED', '#08866d', '#6b7280'],
        'circle-stroke-width': 2,
        'circle-stroke-color': '#fff',
      },
    });
}
